
import { getWithdrawStatus } from '@/api/order/cashOrder'
import { setOrderStatusRules } from '@/utils/rules'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import { AppModule } from '@/store/modules/app'

@Component({
  name: 'setOrderStatus'
  // components: { PicsUploader }
})
export default class extends Vue {
  @Prop({ required: true }) private info!: any
  @Prop({ required: true }) private status!: any

  get language () {
    return AppModule.language
  }
  private setForm: any = {
    status: null,
    remarks: ''
  }
  private rules = setOrderStatusRules
  private loading: boolean = false
  private show: boolean = false

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr () {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private changeStatus (i) {
    if (i === 1) {
      this.show = true
    } else {
      this.show = false
    }
  }

  private back () {
    this.setForm = {
      status: null,
      remarks: ''
    }
    this.$emit('close')
  }

  private async setSuccessStatus () {
    this.loading = true
    const data: any = {
      ordernumber: this.info.ordernumber,
      ...this.setForm
    }
    try {
      await getWithdrawStatus(data, data).then(() => {
        if (this.language === 'en') {
          this.$message({
            message:
              'The task was created successfully, please contact another administrator for approval!',
            type: 'success'
          })
        }
        if (this.language === 'zh_cn') {
          this.$message({
            message: '任务创建成功，请联系其他管理员审批!',
            type: 'success'
          })
        }
        if (this.language === 'zh_tw') {
          this.$message({
            message: '任務創建成功，請聯系其他管理員審批!',
            type: 'success'
          })
        }
        this.loading = false
        this.flagStr()
        this.back()
      })
    } catch (e) {
      this.loading = false
      this.flagStr()
    }
  }
}
